import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';

const MIN_VISIBLE_MS = 380;
const FADE_OUT_MS = 220;

const usePageTransition = () => {
	const location = useLocation();
	const [isVisible, setIsVisible] = useState(false);
	const [isFadingOut, setIsFadingOut] = useState(false);
	const prevPathRef = useRef(location.pathname);
	const timersRef = useRef([]);

	const clearTimers = () => {
		timersRef.current.forEach(clearTimeout);
		timersRef.current = [];
	};

	useEffect(() => {
		if (location.pathname === prevPathRef.current) {
			return undefined;
		}

		prevPathRef.current = location.pathname;
		clearTimers();
		setIsFadingOut(false);
		setIsVisible(true);

		const fadeTimer = setTimeout(() => {
			setIsFadingOut(true);

			const hideTimer = setTimeout(() => {
				setIsVisible(false);
				setIsFadingOut(false);
			}, FADE_OUT_MS);

			timersRef.current.push(hideTimer);
		}, MIN_VISIBLE_MS);

		timersRef.current.push(fadeTimer);

		return clearTimers;
	}, [location.pathname]);

	return { isVisible, isFadingOut };
};

export default usePageTransition;
